import { LoginResponse } from "@/types/auth";
import { v4 as uuid } from 'uuid';

export const AUTH_PW_USER = 1;
export const AUTH_PW_TEMP = 2;

export const isAuthenticated = (response: LoginResponse): boolean => {
  return response.authenticated === AUTH_PW_USER || response.authenticated === AUTH_PW_TEMP;
};

/**
 * Reads the numeric user id from a backend response (canonical key: `userId`). Returns
 * undefined for missing/zero/non-numeric values — callers get a truthy id or nothing.
 */
export const extractUserId = (
  data: { userId?: unknown } | null | undefined,
): number | undefined => {
  const raw = data?.userId;
  if (raw == null || raw === "") return undefined;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

/**
 * Gets (or creates, if one doesn't exist) a session id
 * @returns a string containing the session id
 */
export const getOrCreateSessionId = () => {
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = uuid();
    localStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
}